// Utility function to get authToken from URL query parameter or localStorage
export const getAuthToken = (): string | null => {
  // First check for authToken in URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const urlAuthToken = urlParams.get('authToken');
  
  if (urlAuthToken) {
    return urlAuthToken;
  }
  
  // Fallback to localStorage
  return localStorage.getItem("authToken");
}; 